export function verifyBooleanValue(value: boolean | string | undefined): boolean {
  if (typeof value === "boolean") return value;
  if (value === undefined) return false;
  return value === "true";
}
